/* eslint-disable */
; (function ($) {
    $(document).ready(function () {
        var CHATBOT_LINK = 'https://bicycle-cluster-woodman-chatbot.asiabots.com'
        // use Shopify Liquid 
        var CHATBOT_ICON = '//woodmancomponents.com/cdn/shop/t/10/assets/chatbotlogo.png?v=92616689994336468531784260763'
        var CSS_LINK = '//woodmancomponents.com/cdn/shop/t/10/assets/chatbot.css?v=89752127467123269271784260763'

        $('head').append($('<link rel="stylesheet" type="text/css" />').attr('href', CSS_LINK))
        const body = $('body')
        body.append(
            '<div class="frame-hidden" id="siteNav"><iframe src= "' + CHATBOT_LINK + '" class="frame-myframe"></iframe><button id="frame-close-btn" class="frame-close-button"></button></div>'
        )
        body.append('<div class="iconifier"><a id="frame-launcher-btn"><img src="' + CHATBOT_ICON + '" class="imager"></a></div>')
        var launcher = document.getElementById('frame-launcher-btn')
        var closeIcon = document.getElementById('frame-close-btn')
        var navEl = document.getElementById('siteNav')
        function toggleMenu() {
            navEl.classList.toggle('frame-shown')
            navEl.classList.toggle('is-visible')
            setTimeout(function () {
                navEl.classList.toggle('is-open')
            }, 20)
        }

        launcher.addEventListener('click', toggleMenu)
        closeIcon.addEventListener('click', toggleMenu)
    })
})(jQuery)